import type { Reducer } from "redux";
import type { Action } from "storefront/Action";
import type { SellForm } from "storefront/SellForm";
import { initialState } from "storefront/SellForm";

const sellForm: Reducer<SellForm, Action> = (state = initialState, _action) =>
  state;

export default sellForm;
